import { esc } from "../../utils/format.js";
export const image = (p, cls = "thumb") =>
  p.photos?.[0] ? (
    <img
      className={cls}
      src={esc(p.photos[0])}
      alt={esc(p.name) + " packaging"}
    />
  ) : (
    <div
      className={cls + " placeholder"}
      role={"img"}
      aria-label={"No matching product image for " + esc(p.name)}
    >
      {"Image not assigned"}
    </div>
  );
